import http from '../../../http'

const state = {
    vendorList: [],
    page: {
        current: 1,
        pageSize: 15,
        pageSizes: [15,30,50,100],
        total: 0
    },
    msg_frmData: {
        msgTitle: '',
        msgContent: '',
        attachPath: '',
        raiseUser: '',
        receiveVendor: '',
        msgType: '',
        receiver: ''
    },
    userList: []
};

const mutations = {
    SET_VENDOR_LIST: (state, payload) =>{
        state.vendorList = payload.records;
        state.page.total = payload.total;
    },

    SET_NOTICE_FRM_DATA: (state, payload) =>{
        state.msg_frmData.msgTitle = '';
        state.msg_frmData.msgContent = '';
        state.msg_frmData.attachPath = '';
        state.msg_frmData.raiseUser = payload.currentUser.id;
        state.msg_frmData.receiveVendor = '';
        state.msg_frmData.msgType = 'Notice';
        state.msg_frmData.receiver  = '';
    },

    SET_MSG_FRM_DATA: (state, payload) =>{
        state.msg_frmData.msgTitle = '';
        state.msg_frmData.msgContent = '';
        state.msg_frmData.attachPath = '';
        state.msg_frmData.raiseUser = payload.currentUser.id;
        state.msg_frmData.receiveVendor = payload.row.vendorNo;
        state.msg_frmData.msgType = 'Message';
        state.msg_frmData.receiver  = payload.row.vendorName;
    },
    SET_USER_LIST: (state, payload) =>{
        state.userList = payload;
    },
    SET_PAGE_CURRENT(state, current) {
        state.page.current = current;
    },
    SET_PAGE_SIZE(state, pageSize) {
        state.page.pageSize = pageSize;
    }
};

const actions = {
    getVendorList({commit, state}, payload) {
        let params = {};
        params.current = state.page.current;
        params.size = state.page.pageSize;
        params.keyword = payload;
        http.post('/supplier-resource/system/vendor/PageInfo', params).then((res) => {
            if(res.data.code === '200') {
                commit('SET_VENDOR_LIST',res.data.data);
            }
        });
    },
    submitMsg({commit, state}, params) {
        return new Promise((resolve) => {
            if(!state.msg_frmData.msgContent){
                return;
            }
            if(params && params.length > 0) {
                state.msg_frmData.files = params;
            }else{
                state.msg_frmData.files = '';
            }
            http.fileUpload('/supplier-resource/system/msg/saveMsg', state.msg_frmData).then((res) => {
                if (res.data.code === '200') {
                    resolve(res.data);
                }else {
                    resolve(res);
                }
            });
        });
    },
    getUserListByVendorId({commit}, params) {
        let vendorNo = params.row.vendorNo;
        http.post('/supplier-resource/system/user/listUserByVendor', {vendorNo}).then((res) => {
            if (res.data.code === '200') {
                commit('SET_USER_LIST',res.data.data);
                resolve(res.data);
            }else {
                resolve(res);
            }
        });
    },
    changeVendorStatus({commit}, params) {
        return new Promise(((resolve, reject) => {
            http.post('/supplier-resource/system/vendor/changeStatus', params).then((res) => {
                if(res.data.code === '200') {
                   resolve(res.data);
                }
            })
        }));

    },
    setPageCurrent({dispatch, commit}, pageNum) {
        commit('SET_PAGE_CURRENT', pageNum);
    },
    setPageSize({dispatch, commit}, pageSize) {
        commit('SET_PAGE_SIZE', pageSize);
    },
    uploadStamp({dispatch, commit}, params) {
        return new Promise(((resolve, reject) => {
            http.fileUpload('/supplier-resource/system/vendor/uploadStamp',params).then((res) => {
                resolve(res.data);
            });
        }));
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
